<template>
  <div class="flex flex-col py-4">
    <vs-col
      vs-w="12"
      vs-type="flex"
      vs-align="center"
      vs-justify="space-between"
    >
      <div class="flex">
        <feather-icon
          class="mr-2"
          icon="BookOpenIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        ></feather-icon>
        <h4>Carta de Apresentação</h4>
      </div>

      <vs-button
        class="ml-2"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'presentation-letter' })"
      >
        Editar
      </vs-button>
    </vs-col>

    <hr class="my-4 line" />

    <div class="flex">
      <div v-if="show()">
        <p>
          {{ talent.description }}
        </p>
      </div>
      <div class="flex items-center justify-center w-full" v-else>
        <EmptyDetailCard
          description="Você ainda não preencheu a sua carta de apresentação profissional. Clique em Atualizar Detalhes Profissionais e preencha!"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  name: "presentation-detail-card",
  computed: {
    ...mapState("talent", ["talent"]),
  },
  methods: {
    show() {
      return this.talent.description != "" && this.talent.description != null;
    },
  },
  components: { EmptyDetailCard },
};
</script>

<style lang="scss">
hr {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
</style>
